var searchterm;

$(function () {
    //post to google tag manager, posts after 3secs pause from typing
    var typingTimer;
    var doneTypingInterval = 3000;  //3secs
    var $input = $('.site-search--field [data-search=site]');

    $input.on('keyup', function () {
        clearTimeout(typingTimer);
        typingTimer = setTimeout(doneTyping, doneTypingInterval);
    });

    $input.on('keydown', function () {
        clearTimeout(typingTimer);
    });
});

function doneTyping() {
    if (searchterm !== '' && searchterm !== null && typeof searchterm !== 'undefined' && searchterm != undefined) {
        dataLayer.push({
            'event': 'VirtualPageview',
            'virtualPageURL': '/search?q=' + searchterm,
            'virtualPageTitle': 'Search'
        });
        searchterm = '';
    }
}
//end of google tag manager post functionality

function saveFlight(el, flightNumber) {
    var $headerFlight = $('.header-flight');
    $headerFlight.hide();

    var $flightCard = $(el).parents('.card--content');

    if (flightNumber) {
        if (typeof $.cookie('userSavedFlight') !== 'undefined') {
            $.removeCookie('userSavedFlight');
        }

        $.cookie('userSavedFlight', flightNumber, { path: '/;SameSite=Lax', secure: true });

        var template = $('#header-flight-info-template').html();
        Mustache.parse(template);
        
        var flightInfo = {
            'flightNumber': $.cookie('userSavedFlight'),
            'airlineLogo': $flightCard.find('img')[0].outerHTML,
            'fromTo': $flightCard.find('.toFrom').text(),
            'airport': $flightCard.find('.orgidest').text(),
            'departingArriving': $flightCard.find('.toFrom').text() === 'to' ? 'Depart' : 'Arrive',
            'scheduledTime': $flightCard.find('.schedtime').text(),
            'status': $flightCard.find('.message').text(),
            'statusCssClass': $flightCard.find('.message').attr('class').replace('message', '')
        };

        $('.header-flight-placeholder').show();
        $('.header-flight').addClass('fadeInUp');
        var rendered = Mustache.render(template, flightInfo);
        $('#header-flight-info').html(rendered);
        setTimeout(function () { $headerFlight.show(); }, 0);

        $('.buttonHtml').html('Saved <i class="fa fa-check"></i>');
    }

    ShowFlightSavedMessage();
};

$(document).ready(function () {
    if ($('[data-search=site]').length > 0) {
        //prevent enter key submitting the form
        $('[data-search=site]').keydown(function (event) {
            if (event.keyCode == 13) {
                event.preventDefault();
                return false;
            }
        });

        $('[data-search=site]').focus();

        $('[data-search=site]').autocomplete({
            minLength: 2,
            source: function (request, response) {
                $.ajax({
                    url: '/WebServices/SiteSearch.asmx/SearchResults',
                    type: 'POST',
                    contentType: 'application/json; charset=utf-8',
                    dataType: 'json',
                    data: JSON.stringify({ searchTerm: request.term }),
                    success: function (data) {
                        searchterm = request.term;

                        response($.map(data.d, function (item) {
                            return { label: item.page, page: item.page, pageDescription: item.pageDescription, URL: item.URL, AbsoluteURL: item.AbsoluteURL, DatePublished: item.DatePublished, fltnmbr: item.fltnmbr, schedtime: item.schedtime, origdest: item.origdest, message: item.message, isArrival: item.isArrival, imgPath: item.imgPath, summary: item.summary, statusCssClass: item.statusCssClass, topRanked: item.topRanked, airline: item.airline };
                        }));
                    }
                });
            },
            open: function () {
                $('.results').empty();
                $('.results').append($('.ui-autocomplete').clone().html().replace('<ul', '<div'));
                $('.ui-autocomplete').hide();
                $('.ui-helper-hidden-accessible').remove();
                $('.ndivl').hide();
                $('.null').hide();
            },
            close: function () {

            }
        }).data('ui-autocomplete')._renderItem = function (ul, item) {

            var returnString;

            var summaryVar = item.summary;
            if (summaryVar != null) {
                $('.sticky-footer').css('position', 'inherit');
                $('.resultsSummary').empty();
                $('.resultsSummary').append('<div class="col-12 md-col-8 centered"><p class="lead">' + item.summary + '</p>' + '</div>');
            }

            if (item.page === 'flightCard') {
                var toOrFrom;
                var status;

                if (item.isArrival) {
                    toOrFrom = ' from ';
                } else {
                    toOrFrom = ' to ';
                }

                status = '<span class="message ' + item.statusCssClass + '">';

                var button = ' ';
                if ($.cookie('userSavedFlight') !== item.fltnmbr) {
                    button = '<a class="btn flightSave" onClick="saveFlight(this, \'' + item.fltnmbr + '\');">Save Flight <i class="fa fa-angle-right"></i></a>';
                } else {
                    button = '<a class="btn flightSave">Saved <i class="fa fa-check"></i></a>';
                }

                returnString = $("<div class='card col-12 md-col-8 centered'>" +
                    "<div class='card--content'>" +
                    "<div class='row'>" +
                    "<span class='flight-card--details'>" +
                    '<h3>' +
                    "<span class='flightno'>" + item.fltnmbr + '</span>' +
                    "<span class='toFrom'>" + toOrFrom + '</span>' +
                    "<span class='orgidest'>" + item.origdest + '</span>' +
                    '</h3>' +
                    '<p>Scheduled at <strong><span class="schedtime">' + item.schedtime + '</span></strong></p>' +
                    '</span>' +
                    "<span class='flight-card--status'>" +
                    '<img src="' + item.imgPath + '" alt="' + item.airline + '" />' +
                    '<br>' +
                    status + item.message + '</span>' +
                    '</span>' +
                    '</span>' +
                    '</div>' +
                    "<div class='row buttonHtml'>" +
                    button +
                    '</div>' +
                    '</div>');
            } else {
                if (item.page != null && item.page.indexOf('We believe') >= 0) {
                    returnString = $("<div class='col-12 md-col-8 centered'>" +
                        "<p class='lead'>" + item.page + '</p>' +
                        '</div>');
                } else {
                    if (item.page == null) {
                        returnString = $('');
                    } else {
                        var link;
                        if (item.AbsoluteURL === '') {
                            link = item.page;
                        }
                        else {
                            link = "<a href='" + item.AbsoluteURL + "'>" + item.page + '</a>';
                        }

                        if (item.topRanked) {
                            returnString = $("<div class='col-12 md-col-8 centered topRanked'>" +
                                '<h3>Suggested Search Result:</h3>' +
                                '<h4>' + link + '</h4>' +
                                '<p>' + item.pageDescription + '</p>' +
                                item.URL +
                                '</div>');
                        } else {
                            returnString = $("<div class='col-12 md-col-8 centered'>" +
                                '<hr>' +
                                '<h4>' + link + '</h4>' +
                                '<p>' + item.pageDescription + '</p>' +
                                item.URL +
                                '</div>');
                        }
                    }
                }
            }

            returnString.data('ui-autocomplete-item', item).appendTo(ul);
            return returnString;
        };

        $('[data-search=site]').trigger('keydown');

        if (decodeURIComponent(getUrlVars()['q']) !== 'undefined') {
            var queryStringSearchTerm = decodeURIComponent(getUrlVars()['q']);

            if (queryStringSearchTerm.length > 0) {
                $('[data-search=site]').val(queryStringSearchTerm);
                searchterm = queryStringSearchTerm;
                $('[data-search=site]').autocomplete('search', queryStringSearchTerm);
                doneTyping();
            }
        }
    }
});